"use strict";

// Remove the static import
// import Viewer from 'viewerjs';

export const initViewer = async (selector) => {
    const viewerElements = document.querySelectorAll(selector);

    // Exit early if no elements are found
    if (viewerElements.length === 0) {
        return;
    }

    // Declare variable to hold the dynamically loaded class
    let GLightbox;

    try {
        const ViewerModule = await import('glightbox');
        GLightbox = ViewerModule.default;

        // Check if the GLightbox class was loaded correctly
        if (!GLightbox) {
            console.error("GLightbox class could not be loaded from the module.");
            return;
        }

    } catch (error) {
        console.error("Failed to dynamically load GLightbox:", error);
        return; // Stop initialization if loading failed
    }

    viewerElements.forEach((element) => {
        // Optional: Prevent re-initializing if already done
        if (element.viewerInstance) {
            console.log("Skipping already initialized GLightbox:", element);
            return;
        }

        // Original config setup
        const elementConfig = {};
        if (element.dataset.viewer) {
            elementConfig.href = element.dataset.viewer;
            // Check if video based on file extension
            const videoExtensions = ['mp4', 'webm', 'ogg', 'ogv', 'mov', 'm4v'];
            const fileExtension = elementConfig.href.split('.').pop().toLowerCase();
            if (videoExtensions.includes(fileExtension)) {
                elementConfig.type = 'video';
                elementConfig.source = 'local'; // Indicate that the video is a local file
            } else {
                elementConfig.type = 'image';
            }
        }

        const config = {
            elements: [elementConfig],
            slideEffect: 'none',
            zoomable: true,
            touchNavigation: true,
            keyboardNavigation: false,
            closeOnOutsideClick: true,
            draggable: false,
            autoplayVideos: true,
            autofocusVideos: true,
            skin: 'single'
        }

        try {
            // Initialize using the dynamically loaded Viewer class
            const viewerInstance = GLightbox(config);
            element.viewerInstance = viewerInstance;
            element.addEventListener('click', (event) => {
                viewerInstance.open();
            });
        } catch (initError) {
            console.error("Error initializing GLightbox for element:", element, initError);
        }

    }); // End forEach
};